import React from 'react';
import moment from 'moment';
import ReactDatetime from 'react-datetime';
import 'moment/locale/pt-br';

import {
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from 'reactstrap';

const CustomDatePicker = ({ showIconCalendar = true, ...props }) => {
  const controlChange = (values) => {
    let date = values;

    if (typeof values === 'string') {
      return props.valueController(props.fieldName, formatDate(values));
    }

    if (values._d) {
      date = values._d.toLocaleDateString('pt-br');

      return props.valueController(props.fieldName, date);
    }

    if (values) {
      return props.valueController(props.fieldName, date);
    }

    return props.valueController(props.fieldName, '');
  };

  var valid = function (current) {
    if (props.disabled) {
      return !props.disabled;
    }
    let yesterday = moment().subtract(1, 'day');

    return current.isAfter(yesterday);
  };

  // const isValid = () => {
  //   return !props.disabled;
  // };

  function insertString(originalString, index) {
    return (
      originalString.substring(0, index) + '/' + originalString.substring(index)
    );
  }

  function formatDate(dateString) {
    let cleanString = dateString.replace(/\D/g, ''),
      output = cleanString.substring(0, 8),
      size = dateString.length;

    if (size > 4) output = insertString(output, 4);

    if (size > 2) output = insertString(output, 2);

    return output;
  }

  return (
    <>
      <FormGroup style={{ marginBottom: '0px' }}>
        <InputGroup className="input-group-alternative">
          {showIconCalendar && (
            <InputGroupAddon addonType="prepend">
              <InputGroupText
                style={{ border: '1px solid #c4c4c4', pointerEvents: 'none' }}
              >
                <i className="ni ni-calendar-grid-58" />
              </InputGroupText>
            </InputGroupAddon>
          )}
          <ReactDatetime
            isValidDate={valid}
            closeOnSelect={true}
            closeOnTab={true}
            name={props.fieldName}
            className="reactDate"
            inputProps={{
              disabled: props.disabled,
              style: {
                border: '1px solid #c4c4c4'
              },
              maxLength: 10
            }}
            onChange={controlChange}
            timeFormat={false}
            locale="pt-br"
            value={props.defaultValue}
          />
        </InputGroup>
      </FormGroup>
    </>
  );
};

export default CustomDatePicker;
